"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const contexts_1 = require("@App/contexts");
const Button_1 = require("@Components/Buttons/Button");
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const overclaim_1 = require("@App/api/routes/overclaim");
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
const mobx_react_1 = require("mobx-react");
const DisputeEmailForm = (props) => {
    const { onClose } = props;
    const { userStore, rightsholderStore, overclaimViewStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [emailTemplate, setEmailTemplate] = (0, react_1.useState)();
    const [emailNote, setEmailNote] = (0, react_1.useState)('');
    const [emailSubmitted, setEmailSubmitted] = (0, react_1.useState)(false);
    const overclaimViewItem = overclaimViewStore.overclaimViewItem;
    const publisherNames = (0, react_1.useMemo)(() => overclaimViewItem === null || overclaimViewItem === void 0 ? void 0 : overclaimViewItem.originalPublishers.flatMap((op) => op.administratorPublishers).concat(overclaimViewItem.originalPublishers).filter((pub) => pub.topMemberIpId !== rightsholderStore.currentRightsholderId).map((pub) => pub.publisherName).join(', '), [overclaimViewItem === null || overclaimViewItem === void 0 ? void 0 : overclaimViewItem.originalPublishers]);
    (0, react_1.useEffect)(() => {
        var _a;
        (0, overclaim_1.renderOverclaimEmailTemplate)((_a = overclaimViewItem === null || overclaimViewItem === void 0 ? void 0 : overclaimViewItem.overclaimHeaderId) !== null && _a !== void 0 ? _a : 0, rightsholderStore.currentRightsholderId).then((result) => {
            setEmailTemplate(result.data.replaceAll('&#39;', "'").replaceAll(/\(http.*?\)/g, ''));
        });
    }, []);
    const onEmailNoteChange = (event) => setEmailNote(event.target.value);
    const onSend = () => __awaiter(void 0, void 0, void 0, function* () {
        yield overclaimViewStore.sendOverclaimEmail(emailNote);
        setEmailSubmitted(true);
    });
    return (react_1.default.createElement(react_1.default.Fragment, null, emailSubmitted ? (react_1.default.createElement(Popup_1.default, { className: 'dispute-success-popup', onClose: onClose, showClose: true },
        react_1.default.createElement(ConfirmationPopup_1.default, { title: 'Email Sent!', confirmButtonText: 'Done', onConfirm: onClose },
            react_1.default.createElement("div", { className: 'dispute-success-text' }, "An email has been sent to all parties involved in this overclaim")))) : (react_1.default.createElement(Popup_1.default, { className: 'dispute-popup', onClose: () => { } },
        react_1.default.createElement("div", { className: 'dispute-email-form' },
            react_1.default.createElement("div", { className: 'dispute-email-form-header' },
                react_1.default.createElement("img", { src: common_1.ICONS.email, alt: 'email icon' }),
                react_1.default.createElement("h5", null, "Email All Claimants"),
                react_1.default.createElement("span", null, "This email will be sent to all claimants involved on this work to attempt to resolve the overclaim.")),
            react_1.default.createElement("div", { className: 'email-content-section' },
                react_1.default.createElement("div", { className: 'email-content-header' },
                    react_1.default.createElement("span", { className: 'to-cc-section' },
                        react_1.default.createElement("div", { className: 'recipient-line' },
                            react_1.default.createElement("strong", null, "To:"),
                            publisherNames),
                        react_1.default.createElement("div", { className: 'cc-line' },
                            react_1.default.createElement("strong", null, "Cc: "),
                            " ",
                            userStore.userInfo.email)),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("span", null,
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("strong", null, "Subject: "),
                            "Overclaim on your work ",
                            react_1.default.createElement("strong", null, overclaimViewItem === null || overclaimViewItem === void 0 ? void 0 : overclaimViewItem.title),
                            " (Overclaim ID#", overclaimViewItem === null || overclaimViewItem === void 0 ? void 0 :
                            overclaimViewItem.overclaimHeaderId,
                            ")"))),
                react_1.default.createElement("br", null),
                react_1.default.createElement("div", { className: 'email-content-body' }, emailTemplate !== null && emailTemplate !== void 0 ? emailTemplate : react_1.default.createElement(PointPreloader_1.default, null))),
            react_1.default.createElement("div", { className: 'dispute-email-form-input' },
                react_1.default.createElement("label", { htmlFor: 'dispute-email-note-input' }, "Add your own note"),
                react_1.default.createElement("input", { id: 'dispute-email-note-input', type: 'text', value: emailNote, onChange: onEmailNoteChange }),
                react_1.default.createElement("div", { className: 'form-button-row' },
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: onClose }, "Cancel"),
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: onSend }, "Submit"))))))));
};
exports.default = (0, mobx_react_1.observer)(DisputeEmailForm);
